import ky from 'ky'
import Auth2 from 'plugin/src/shared/Auth2'
import { API_BASE_URL } from '@mote/config/constants'
import { ANALYTICS_PARAMS_BLACKLIST } from '@mote/helpers/constants'
import { isInExtension } from '@mote/helpers/extension'

const apiClient = ky.extend({
  prefixUrl: API_BASE_URL
})

const inExtension = isInExtension()

export function identifyUser(userPayload = {}, userId = null) {
  const user = Object.assign({}, inExtension ? Auth2.getCache() : userPayload)
  apiClient.post('s/identify/everything', {
    json: {
      ...sanitizeUserParams(user),
      userId: inExtension ? Auth2.getUserId() : userId
    }
  })
}

// helpers
function sanitizeUserParams(user) {
  for (const key of ANALYTICS_PARAMS_BLACKLIST) {
    if (key in user) {
      user[key] = undefined
    }
  }
  user['from_extension'] = '1'
  if (user.primaryEmailAddress) {
    const email = user.primaryEmailAddress
    user.primaryEmailAddress = undefined
    user['email'] = email
    const atSymbolIndex = email.indexOf('@')
    if (atSymbolIndex > 0 && email.length > atSymbolIndex + 1) {
      user['email_domain'] = email
        .slice(atSymbolIndex + 1, email.length)
        .toLowerCase()
    }
  }
  if (
    user.isMinor === true ||
    user.isMinor === 'true' ||
    user.isMinor === 'True' ||
    user.isMinor === '1' ||
    user.isMinor === 1
  ) {
    user.isMinor = '1'
  } else {
    user.isMinor = '0'
  }

  if (inExtension) return user

  return enrichTrackingData(user)
}

function enrichTrackingData(user) {
  user['tracking_source'] = 'website'
  user['tracking_route'] = 'direct'

  return user
}
